module.exports = __webpack_public_path__ + "static/img/WILLEM-DUURSMA.dc71f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILLEM-DUURSMA.jpg
// module id = gmx9
// module chunks = 0